import axios from 'axios';

import {
  GET_ALLIDO_DETAILS_ENDPOINT,
  GET_IDO_DETAIL_ENDPOINT,
  GET_NFT_DETAIL_ENDPOINT,
  GET_ONGOINGIDOS_ENDPOINT,
  GET_ONGOINGNFTS_ENDPOINT,
  GET_PASTIDOS_ENDPOINT,
  GET_PASTINFTS_ENDPOINT,
  GET_SCROLLING_MESSAGES,
  GET_UPCOMINGIDOS_ENDPOINT,
  GET_UPCOMINGNFTS_ENDPOINT
} from './endpoints';

export const getIDONFTDetails = async () => {
  return await axios.get(GET_ALLIDO_DETAILS_ENDPOINT);
};

export const getOngoingIDODetails = async (limit, offset) => {
  return await axios.get(GET_ONGOINGIDOS_ENDPOINT(limit, offset));
};
export const getPastIDODetails = async (limit, offset) => {
  return await axios.get(GET_PASTIDOS_ENDPOINT(limit, offset));
};
export const getUpcommingIDODetails = async (limit, offset) => {
  return await axios.get(GET_UPCOMINGIDOS_ENDPOINT(limit, offset));
};

export const getTokenDetail = async (tokenID) => {
  return await axios.get(`${GET_IDO_DETAIL_ENDPOINT}${tokenID}`);
};

export const getScrollingMessages = async () => {
  return await axios.get(GET_SCROLLING_MESSAGES);
};

export const getOngoingNftDetails = async (limit, offset) => {
  return await axios.get(GET_ONGOINGNFTS_ENDPOINT(limit, offset));
};
export const getPastNftDetails = async (limit, offset) => {
  return await axios.get(GET_PASTINFTS_ENDPOINT(limit, offset));
};
export const getUpcommingNftDetails = async (limit, offset) => {
  return await axios.get(GET_UPCOMINGNFTS_ENDPOINT(limit, offset));
};

export const getNFTDetail = async (tokenID) => {
  return await axios.get(GET_NFT_DETAIL_ENDPOINT(tokenID));
};
